import { Component, Input } from '@angular/core';

@Component({
    selector: 'zwi-ministry-embed-cover-art',
    imports: [],
    templateUrl: './ministry-embed-cover-art.component.html',
    styleUrl: './ministry-embed-cover-art.component.scss'
})
export class MinistryEmbedCoverArtComponent {
  @Input() backgroundImage = '';
  get backgroundImageUrl() {
    return this.backgroundImage === '' ? '' : `url(${this.backgroundImage})`;
  }
}
